import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";
import "../style_v2.css";
import "../style.css";

const MasLibIntro = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("MasLibIntro", "product_lib/product_lib_intro_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.MasLibIntro || { Main: {} };

  return (
    <div className="container-fluid aiprojects bg-light py-5" id="mas_lib">
      <div className="container py-5">
        <div className="row g-5">
          {/* 左側文字區塊 */}
          <div className="col-lg-5 wow fadeInLeft" data-wow-delay="0.2s">
            <div>
              <h4 className="text-primary">{LANGUAGE.Main.Content1}</h4>
              <h1 className="display-4 mb-4">{LANGUAGE.Main.Content2}</h1>
              <p className="mb-5">{LANGUAGE.Main.Content3}</p>
              <ul className="nav">
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3 active" data-bs-toggle="pill" href="#aiprojectsTab-1">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-book small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab1Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill" href="#aiprojectsTab-2">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-tools small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab2Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill" href="#aiprojectsTab-3">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-chart-line small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab3Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill" href="#aiprojectsTab-4">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-chart-pie small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab4Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* 右側內容區塊 */}
          <div className="col-lg-7 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-content">
              <div id="aiprojectsTab-1" className="tab-pane fade show p-0 active">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_lib_1} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_lib_1} className="img-fluid w-100" alt="Docs" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-3">{LANGUAGE.Main.Tab1Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab1Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank" 
                      href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>{LANGUAGE.Main.CTA}</a>
                    <a className="btn btn-secondary py-2 px-4 ms-3" target="_blank" href="https://doc.mindaismart.com/">{LANGUAGE.Main.DOC}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>

              <div id="aiprojectsTab-2" className="tab-pane fade show p-0">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_lib_2} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_lib_2} className="img-fluid w-100" alt="Tools" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-3">{LANGUAGE.Main.Tab2Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab2Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank" 
                      href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>{LANGUAGE.Main.CTA}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>

              <div id="aiprojectsTab-3" className="tab-pane fade show p-0">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_lib_3} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_lib_3} className="img-fluid w-100" alt="Performance" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-3">{LANGUAGE.Main.Tab3Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab3Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank"
                      href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>{LANGUAGE.Main.CTA}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>

              <div id="aiprojectsTab-4" className="tab-pane fade show p-0">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_lib_4} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_lib_4} className="img-fluid w-100" alt="Data" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-4">{LANGUAGE.Main.Tab4Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab4Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank" 
                      href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>{LANGUAGE.Main.CTA}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Right */}
        </div>
      </div>
    </div>
  );
};

export default MasLibIntro;
